/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * How far the suspension reaches.
 */
export type VehicleSuspensionDtoKind = typeof VehicleSuspensionDtoKind[keyof typeof VehicleSuspensionDtoKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleSuspensionDtoKind = {
  FULL: 'FULL',
  RESTRICTED: 'RESTRICTED',
} as const;
